import type { ComponentPropsWithoutRef } from 'react';
import { cx } from '@parrot/utils';
import '../../styles/tokens.css';
import styles from './ProductSuiteButton.module.css';

interface ProductSuiteButtonProps extends ComponentPropsWithoutRef<'button'> {
  /**
   * Colour theme, matching <ProductSuite />. Omit for the dark palette; drives the
   * pill's surface and border tokens.
   */
  theme?: 'dark' | 'light';
}

/**
 * The canonical "Product Suite" launcher pill — presentational only. Wire up what
 * it does (navigate, open an overlay, …) via the standard button props passed
 * through, e.g. `onClick`.
 *
 * The accent is a single knob: `--ps-button-color` (defaults to gold). Set it from
 * the `className` you put on this base element and it re-themes the icon, label,
 * hover border and glow together — everything downstream is `currentColor`.
 */
export function ProductSuiteButton({
  className,
  theme,
  type = 'button',
  ...rest
}: ProductSuiteButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      data-theme={theme}
      className={cx('parrot-product-suite', styles.base, className)}
    >
      <svg
        width={'14'}
        height={'14'}
        viewBox={'0 0 24 24'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={'2.5'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        aria-hidden={'true'}
      >
        <rect x={'2'} y={'2'} width={'9'} height={'9'} rx={'2'} />
        <rect x={'13'} y={'2'} width={'9'} height={'9'} rx={'2'} />
        <rect x={'2'} y={'13'} width={'9'} height={'9'} rx={'2'} />
        <rect x={'13'} y={'13'} width={'9'} height={'9'} rx={'2'} />
      </svg>
      <span className={styles.label}>Product Suite</span>
    </button>
  );
}
